'use client'

import { HugeiconsIcon } from '@hugeicons/react'
import { MagicWand01Icon } from '@hugeicons-pro/core-stroke-rounded'
import { useChat } from '@/contexts/ChatContext'
import { cn } from '@/lib/utils'

type AskAiChipProps = {
  field?: string
  seedMessage?: string
  className?: string
}

export function AskAiChip({ field, seedMessage, className }: AskAiChipProps) {
  const { openChat, pendingCommandFormContext, setPendingCommandFormContext } = useChat()

  return (
    <button
      type="button"
      className={cn('inline-flex items-center gap-1 rounded-full border border-atrium-border bg-atrium-background px-2 py-0.5 text-xs font-medium text-atrium-black/60 transition-colors hover:border-accent-600/40 hover:text-accent-700', className)}
      onClick={() => {
        setPendingCommandFormContext(pendingCommandFormContext
          ? { ...pendingCommandFormContext, focusedField: field }
          : {
              commandId: null,
              pathname: typeof window !== 'undefined' ? window.location.pathname : '/commands/new',
              formState: {} as never,
              focusedField: field,
            })
        openChat(null, {
          seedMessage: seedMessage || `Help me with ${field ? field.replace(/_/g, ' ') : 'this command'}.`,
        })
      }}
    >
      <HugeiconsIcon icon={MagicWand01Icon} className="size-3" />
      Ask AI
    </button>
  )
}
